import { render, staticRenderFns } from "./MerAllStoreDetailSummary.vue?vue&type=template&id=1328c258&scoped=true&"
import script from "./MerAllStoreDetailSummary.vue?vue&type=script&lang=js&"
export * from "./MerAllStoreDetailSummary.vue?vue&type=script&lang=js&"
import style0 from "./MerAllStoreDetailSummary.vue?vue&type=style&index=0&id=1328c258&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1328c258",
  null
  
)

export default component.exports